import { render, staticRenderFns } from "./document-card.vue?vue&type=template&id=6f2f46f2&scoped=true&"
import script from "./document-card.vue?vue&type=script&lang=js&"
export * from "./document-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f46f2",
  null
  
)

export default component.exports